import { render, staticRenderFns } from "./AddDowntimeReasonModal.vue?vue&type=template&id=2ad41d9e"
import script from "./AddDowntimeReasonModal.vue?vue&type=script&lang=js"
export * from "./AddDowntimeReasonModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports